export default {"src":"/_next/static/media/google-play-Store.6ba3105b.svg","height":53,"width":180,"blurWidth":0,"blurHeight":0};